import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CreateVisitType } from '../../../entity';
import { PreviewVisit } from '../../visit-daily-overview-diagram';
import DayTimelineView from '../../visit-daily-overview-diagram';
import { useServicesQuery } from '@features/service/queries';

type ReservationTimelineProps = {
  previewVisit: PreviewVisit | undefined;
  setPreviewVisit: React.Dispatch<React.SetStateAction<PreviewVisit | undefined>>;
};

export const ReservationTimeline = ({
  previewVisit,
  setPreviewVisit,
}: ReservationTimelineProps) => {
  const { setValue, getValues, control } = useFormContext<CreateVisitType>();
  const date = useWatch({ control, name: 'date' });
  const { data: servicesData } = useServicesQuery();

  const handleTimelineSlotClick = useCallback(
    (time: string) => {
      const [h, m] = time.split(':');
      const start = dayjs(getValues('date')).hour(+h).minute(+m);
      const end = start.add(1, 'hour');
      setValue('date', start.toDate());
      setValue('dateTo', end.toDate());
      const serviceName = servicesData?.find(s => s.id === getValues('serviceIds'))?.serviceName;
      setPreviewVisit({
        startTime: start.format('HH:mm'),
        endTime: end.format('HH:mm'),
        serviceName,
      });
    },
    [getValues, setValue, servicesData, setPreviewVisit],
  );

  if (!date) {
    return null;
  }

  return (
    <DayTimelineView
      date={date}
      previewVisit={previewVisit}
      onSlotClick={handleTimelineSlotClick}
    />
  );
};
